/* eslint-disable no-undef */
document.addEventListener('DOMContentLoaded', function() {
  // Add 'empty' class for empty selects
  const selects = document.querySelectorAll('.js-select');
  if (selects) {
    selects.forEach(select => {
      select.addEventListener('change', () => {
        if (select.value === null || select.value === '') {
          select.classList.add('empty');
        }
        else {
          select.classList.remove('empty');
        }
      });
      // Trigger 'change' event on all selects
      const event = new Event('change');
      select.dispatchEvent(event);
    });
  }

  // Remove errors on inputs click
  document.addEventListener('click', function(e) {
    // loop parent nodes from the target to the delegation node
    for (var target = e.target; target && target != this; target = target.parentNode) {
      // If click was on select, input or textarea element
      if (target.matches('select, input, textarea') || target.closest('select, input, textarea')) {
        target.classList.remove('error');
        break;
      }
    }
  }, false);
});
